import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';

import './ReactionCiStageDetails.scss';

export default class ReactionCIStageDetailsComponent extends React.Component {
  constructor(props) {
    super(props);

    this.getFact = this.getFact?.bind(this);
    this.getContentSpan = this.getContentSpan?.bind(this);
    this.getTechnologies = this.getTechnologies?.bind(this);
    this.getKeywords = this.getKeywords?.bind(this);
    this.getIdentifies = this.getIdentifies?.bind(this);
    this.getComments = this.getComments?.bind(this);
  }

  getFact(title, content, measure = '', regex = null) {
    const requireMeasure = regex ? !content.match(regex) : true;
    const contentSpan = this.getContentSpan(content);

    if (!requireMeasure) {
      return (
        <div className="ci-details-row">
          <b>{title}: </b> {contentSpan}
        </div>
      );
    }

    return (
      <div className="ci-details-row">
        <b>{title}: </b> {contentSpan} {measure}
      </div>
    );
  }

  // eslint-disable-next-line class-methods-use-this
  getContentSpan(content) {
    return <InnerHTML tag="span" mode="escape" extendedTags html={content} />;
  }

  getTechnologies(detail) {
    return (
      <div className="ci-details-row">
        <b>Technology: </b>
        {detail?.technologies?.map((technology, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={`${technology}_${index}`}>
            {this.getContentSpan(technology)}
            {index < (detail?.technologies?.length || 0) - 1 ? '; ' : ''}
          </React.Fragment>
        ))}
      </div>
    );
  }

  getKeywords(detail) {
    return (
      <div className="ci-details-row">
        <b>Keywords: </b>
        {detail?.keywords?.map((keyword, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={`${keyword.keyword}_${index}`}>
            {this.getContentSpan(keyword.keyword)}({this.getContentSpan(keyword.type)})
            {index < (detail?.keywords?.length || 0) - 1 ? ' ;' : ''}
          </React.Fragment>
        ))}
      </div>
    );
  }

  getIdentifies(detail) {
    return (
      <div className="ci-details-row">
        <b>Identifiers: </b>
        {detail?.identifies?.map((identifyInfo, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={`${identifyInfo.identifier}_${index}`}>
            {this.getContentSpan(identifyInfo.identifier)}({this.getContentSpan(identifyInfo.type)})
            {index < (detail?.identifies?.length || 0) - 1 ? '; ' : ''}
          </React.Fragment>
        ))}
      </div>
    );
  }

  getComments(detail) {
    return detail?.comments?.map((comment, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <React.Fragment key={`${comment.type}_${index}`}>
        <InnerHTML
          className="ci-details-group--trust-html ci-details-row"
          tag="div"
          mode="escape"
          extendedTags
          allowedAttributes={['colspan']}
          html={comment.comment}
        />
        ({this.getContentSpan(comment.type)}){index < (detail?.comments?.length || 0) - 1 ? '; ' : ''}
      </React.Fragment>
    ));
  }

  render() {
    const { detail, largestProduct } = this.props;

    return (
      <div className="ci-reaction-details">
        <div className="ci-details-group u-els-margin-top">
          {detail.scale && this.getFact('Reaction Scale', detail.scale, 'mol', /mol|g/gi)}
          {detail.nextMoveRType && this.getFact('NextMove Reaction Type', detail.nextMoveRType)}
          {detail.reactionName && this.getFact('Reaction Name', detail.reactionName)}
          {largestProduct && this.getFact('MW Largest Product', largestProduct, 'g/mol')}
        </div>

        <div className="ci-details-group u-els-margin-top">
          {detail.experimentType && this.getFact('Experiment Type', detail.experimentType)}
          {detail?.technologies?.length > 0 && this.getTechnologies(detail)}
          {detail.qualification && <div>{this.getFact('Qualification', detail.qualification)}</div>}
          {detail?.keywords?.length > 0 && this.getKeywords(detail)}
          {detail?.identifies?.length > 0 && this.getIdentifies(detail)}
          {detail.source && this.getFact('Source', detail.source)}
        </div>

        <div className="ci-details-group u-els-margin-top">
          {detail.preparative && this.getFact('Preparative', detail.preparative)}
          {detail.conclusionPhrase && this.getFact('Conclusion Phrase', detail.conclusionPhrase)}
          {detail.analyticalDataExist && this.getFact('Analytical Data Exists', detail.analyticalDataExist)}
        </div>

        <div className="ci-details-group u-els-margin-top">{detail.comments && detail.comments.length && this.getComments(detail)}</div>
      </div>
    );
  }
}

ReactionCIStageDetailsComponent.propTypes = {
  detail: PropTypes.object.isRequired,
  largestProduct: PropTypes.string,
};
